import styled from 'styled-components';
import { friendlyDimensionName } from '../../../../../../../common/model/texts/friendly-dimension-name';
import { Dimension, ORDERED_IMPACTS_BY_DIMENSION, Valence } from '../../../../../../../common/model/types';
import { getTitleStyle } from '../../../../../generic/content/texts/bou-title/title-style';
import { BouColor } from '../../../../../generic/global/bou-colors';
import { BouSpacingLevel, fluidSpacing } from '../../../../../generic/layout/bou-spacing';
import { stepRange } from './shared';
import { ValenceBlock } from './valence-block';

interface Props {
  dimension: Dimension;
}

export function DimensionBlock(props: Props) {
  const impactCategories = ORDERED_IMPACTS_BY_DIMENSION[props.dimension];
  return (
    <Root>
      <TableRoot>
        <thead>
          <TitleRow>
            <Title>{friendlyDimensionName(props.dimension)}</Title>
            <TitleRowNumber>{stepRange[0]}</TitleRowNumber>
            {stepRange.slice(0, stepRange.length - 2).map(index => (
              <td key={index} />
            ))}
            <TitleRowNumber>{stepRange[stepRange.length - 1]}</TitleRowNumber>
          </TitleRow>
        </thead>
        <tbody>
          {[Valence.POSITIVE, Valence.NEGATIVE].map(valence => (
            <ValenceBlock
              key={valence}
              valence={valence}
              impactCategories={impactCategories}
              dimension={props.dimension}
            />
          ))}
        </tbody>
      </TableRoot>
    </Root>
  );
}

const Root = styled.div`
  ${fluidSpacing('padding-bottom', BouSpacingLevel.TINY)}
  ${fluidSpacing('padding-top', BouSpacingLevel.TINY)}
  & + & {
    border-top: 2px solid #eeeeee;
  }
`;

const TableRoot = styled.table`
  border-collapse: collapse;
`;

const Title = styled.td`
  ${getTitleStyle({ size: 'h7' })}
  width: 15em;
  table-layout: fixed;
`;

const TitleRow = styled.tr``;

const TitleRowNumber = styled.td`
  text-align: center;
  color: ${BouColor.TOOL_TEXT_DARK_GRAY};
`;
